import { Controller } from 'libraries/front-end-core/core/Router'
import getUrl from 'libraries/front-end-core/core/url'
import { MW_DEAL_DETAILS } from 'constants/controllers'
import Header from 'components/dealwatch/header'
import Main from 'redux/containers/pages/mwdealdetails/DealDetailsContainer'

export default new Controller({
  name: MW_DEAL_DETAILS,
  route: '(:aol/)markets/dealdetails/:dealId',
  controller (Router, { url: pageId, pageView, params: { aol, dealId }, query }, render) {
    render(
      { Main, Header },
      { aol, dealId, query, controller: MW_DEAL_DETAILS },
      {
        aol,
        pageId: getUrl(MW_DEAL_DETAILS),
        pageView,
        searchType: 'dealwatch',
        className: 'dealwatch'
      }
    )

    return pageId
  }
})
